export default "__VITE_ASSET__Cxy1sUg1__"